/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventsLookup } from '../../models/harvest-events-lookup';
import { HarvestEventsLookupDto } from '../../models/harvest-events-lookup-dto';

export interface UpdateHarvestEventsLookup$Params {
  harvestEventsLookupId: number;
      body: HarvestEventsLookupDto
}

export function updateHarvestEventsLookup(http: HttpClient, rootUrl: string, params: UpdateHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
  const rb = new RequestBuilder(rootUrl, updateHarvestEventsLookup.PATH, 'put');
  if (params) {
    rb.path('harvestEventsLookupId', params.harvestEventsLookupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestEventsLookup>;
    })
  );
}

updateHarvestEventsLookup.PATH = '/api/harvesteventslookup/{harvestEventsLookupId}';
